import { generateFaqUrl } from 'src/Feature/Faq/app';
import { UrlTokenType } from '../models/url-token-type';
import { replaceUrlTokens } from './replace-url-tokens';
var faqTokenRegex = /\[faq\|[0-9a-z\-]+\]/mgi;
export var replaceFaqTokens = function (html, product) {
    faqTokenRegex.lastIndex = 0;
    return product ? replaceUrlTokens(faqTokenRegex, UrlTokenType.Faq, product, html, generateFaqUrl) : html;
};
